<template>
  <section id="hero">
    <v-parallax
      src="@/assets/img/bg-hero.png"
      :height="height"
      class="hero-parallax"
    >
      <v-row
        align="center"
        justify="center"
        class="hero-parallax__row fill-height ma-0"
      >
        <v-col cols="12">
          <v-row align="center" justify="center" class="fill-height ma-0">
            <v-col
              cols="12"
              md="5"
              xl="4"
              sm="3"
              class="ml-6 hero-parallax__copy"
            >
              <div class="display-1 header mb-4 hero-parallax__title">
                <p class="fontsize30px mb-0">Built for Medical Reps</p>
              </div>
              <h1 class="hero-parallax__subtitle">
                An easy tool to assist Medical Representative's<br />
                on the field <br />
              </h1>

              <div class="d-flex flex-wrap ga-2 mt-5">
                <a
                  href="https://play.google.com/store/apps/details?id=com.mobil80.pharmawrk"
                  target="_blank"
                  class="hero-parallax__store-link"
                >
                  <v-icon>mdi-google-play</v-icon>
                  Google Play
                </a>

                <a
                  href="https://apps.apple.com/in/app/pharmawrk/id1575723537"
                  target="_blank"
                  class="hero-parallax__store-link"
                >
                  <v-icon>mdi-apple</v-icon>
                  App Store
                </a>
              </div>

              <v-btn
                v-if="$vuetify.display.mdAndUp"
                color="primary"
                rounded
                variant="outlined"
                size="large"
                class="mt-7 hero-parallax__know-more"
                @click="scrollToFeatures"
              >
                Know More
                <v-icon class="ml-2">mdi-arrow-down</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down"> </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div> -->
    </v-parallax>
    <v-container fluid id="features">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="space-around">
            <v-col
              cols="12"
              sm="4"
              class="text-center"
              v-for="(feature, i) in features"
              :key="i"
            >
              <v-hover v-slot="{ isHovering, props }">
                <v-card
                  class="card CardBorderRadius"
                  :elevation="isHovering ? 10 : 4"
                  :class="{ up: isHovering }"
                  v-bind="props"
                >
                  <v-img
                    :src="feature.img"
                    max-width="100px"
                    class="d-block ml-auto mr-auto"
                    :class="{ 'zoom-efect': isHovering }"
                  ></v-img>
                  <h1 class="font-weight-regular">{{ feature.title }}</h1>
                  <h4 class="font-weight-regular subtitle-1">
                    {{ feature.text }}
                  </h4>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-dialog v-model="dialog" max-width="640px">
      <v-card>
        <youtube
          :video-id="videoId"
          @ready="ready"
          @playing="playing"
        ></youtube>
      </v-card>
    </v-dialog> -->
    <div class="svg-border-waves mt-n4">
      <v-img src="@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      height: 0,
      videoId: "i8IvvHJssWE",

      features: [
        {
          img: require("@/assets/img/a1.png"),
          title: "Optimize your visits",
          text: "Quick and easy access to help you decide on where to visit next, based on your current location",
        },
        {
          img: require("@/assets/img/a2.png"),
          title: "Access your Visit Logs",
          text: "Log of all of the representative’s recent visits, available to the business on a geo-spatial map on the web portal",
        },
        {
          img: require("@/assets/img/a3.png"),
          title: "Access learning literature",
          text: "Access drug and medical equipment related literature right from your mobile device and easily share it with doctors and health professionals",
        },
      ],
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },

  mounted() {
    this.height = window.innerHeight;
  },

  methods: {
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      console.log(event);
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    scrollToFeatures() {
      const el = document.querySelector("#features");
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80; // optional offset
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  },
};
</script>

<style lang="scss">
.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  // -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}

.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  // -webkit-transition: all 0.5s ease;

  .triangle {
    // -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }

  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
@media only screen and (max-width: 400px) {
  .header h1 {
    font-size: 31px;
  }
}
</style>

<style>
.btn-play {
  transition: 0.2s;
}

.hero-parallax :deep(.v-parallax__content) {
  display: flex;
  align-items: center;
  min-height: 100%;
}

.hero-parallax :deep(.v-img__img) {
  filter: none;
  opacity: 1;
}

.hero-parallax__know-more {
  background: transparent !important;
}

.hero-parallax__row {
  width: 100%;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#hero {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
</style>

<style>
section {
  position: relative;
}
</style>
